import { useState } from "react";
import { Button } from "@mantine/core";
import { IconDownload } from "@tabler/icons-react";
import { notifications } from "@mantine/notifications";

interface ReportExportButtonProps {
  filename: string;
  fetchData: () => Promise<string>;
}

export function ReportExportButton({
  filename,
  fetchData,
}: ReportExportButtonProps) {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      const csv = await fetchData();
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch {
      notifications.show({
        title: "Export failed",
        message: "Could not download the report. Please try again.",
        color: "red",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      leftSection={<IconDownload size={16} />}
      variant="light"
      loading={loading}
      onClick={handleExport}
    >
      Export CSV
    </Button>
  );
}
